import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CategorySearchData } from '../_models/category-search-data';
import { CategorySearchDetails } from '../_models/category-search-details';

@Injectable({
  providedIn: 'root'
})


/*----Service for Category Search---*/
export class CategorySearchService {
  params: string;
  


  constructor(private http: HttpClient) { }
  /* CategorySearch Controller URL's*/
  public static readonly GET_CATEGORY_WITH_SUB_CATEGORY_CONTROLLER = environment.apiURL + 'getParentCategoryWithSubLevels/';
  public static readonly GET_CATEGORY_SEARCH_DETAILS_BY_ID = environment.apiURL + 'getCategoryDetailsById/';
  public static readonly GET_SORTED_PRODUCTS = environment.apiURL + 'getCategoryDetailsById/';
  public static readonly GET_AVAILABLE_STOCK = environment.stockURL + 'erpRestService/api/stockitems/availableQnty';

  /*-----Method to fetch all categories with parent category names-------*/
  public getCategoryWithSubCategory(userId): Observable<CategorySearchData[]> {
    this.params = "?userId=" + userId
    return this.http.get<CategorySearchData[]>(CategorySearchService.GET_CATEGORY_WITH_SUB_CATEGORY_CONTROLLER + this.params)
      .pipe(map(response => {
        return response;
      }));

  }

  /*Method for fetching all category details-----*/
  public getCategoryDetailsById(id, userId, keyValue, searchKeyword): Observable<CategorySearchDetails> {
    console.log(searchKeyword)
    if (keyValue == undefined) {
      this.params = "?categoryId=" + id + "&userId=" + userId + "&searchKeyword=" + searchKeyword
    } else {
      this.params = "?categoryId=" + id + "&userId=" + userId + "&keyValue=" + keyValue + "&searchKeyword=" + searchKeyword;
    }


    return this.http.get<CategorySearchDetails>(CategorySearchService.GET_CATEGORY_SEARCH_DETAILS_BY_ID + this.params)
      .pipe(map(response => {
        return response;
      }));
  }

  public getSortedProducts(categoryId: Number, userId: any, event: any): Observable<CategorySearchDetails> {
    let params = "?categoryId=" + categoryId + "&userId=" + userId + "&event=" + event;

    return this.http.get<CategorySearchDetails>(CategorySearchService.GET_SORTED_PRODUCTS + params)
      .pipe(map(response => {
        return response;
      }));
  }
  
  public getStockDetails(stockListRequest:any){
    let headers = new HttpHeaders().set('Authorization', 'Basic dXNlcjpwYXNzd29yZA==');
headers = headers.set('Content-Type', 'application/json');
    
    return this.http.post(CategorySearchService.GET_AVAILABLE_STOCK, stockListRequest,  {headers:headers});
  }
}
